<div class="online-map-summary">
    <div id="details-view-container">
      <offline-nothing-selected-summary  [hidden]="!viewToShowObject.noSelection"></offline-nothing-selected-summary>

      <offline-node-summary [selection]="selection" [hidden]="!viewToShowObject.nodeSelection"></offline-node-summary>

      <offline-voip-peer-summary [selection]="selection" [hidden]="!viewToShowObject.voipPeerSelection"></offline-voip-peer-summary>

      <offline-voip-peer-aggregation-summary [selection]="selection"
        [hidden]="!viewToShowObject.voipPeerAggregationSelection"></offline-voip-peer-aggregation-summary>

      <offline-connection-summary [selection]="selection" [hidden]="!viewToShowObject.connectionSelection"></offline-connection-summary>

      <offline-peer-connection-summary [selection]="selection" [hidden]="!viewToShowObject.peerConnectionSelection"></offline-peer-connection-summary>

      <offline-peer-connection-aggregation-summary [selection]="selection"
        [hidden]="!viewToShowObject.peerConnectionAggregationSelection"></offline-peer-connection-aggregation-summary>
    </div>
</div>
